import React, { useEffect, useState } from 'react';
import { Form, Select, Spin, Row, Col, Input, Button, Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import map from 'lodash/map';
import find from 'lodash/find';
import assign from 'lodash/assign';
import MediaUploadModal from '../../../components/product/mediaUploadModal';
import AddCategory from '../../../components/product/addCategory';
import { productMangement } from '../../../redux/actions/productAction';

const { Option } = Select;

const ProductDetailsForm = (props) => {
  const { onSubmitPayload, currentStep, initialValues, edit, isMarketingUser } =
    props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [media, setMedia] = useState(
    initialValues ? get(initialValues, 'media', []) : []
  );

  const dispatch = useDispatch();
  const selectedCompany = useSelector((state) =>
    get(state, 'auth.selectedCompany')
  );
  const userComapnies = useSelector((state) =>
    get(state, 'auth.userCompanies')
  );

  const getComapnyId = () => {
    if (isMarketingUser && initialValues) {
      return get(initialValues, 'company_id');
    }
    return isMarketingUser ? undefined : get(selectedCompany, 'id');
  };

  const [companyId, setCompanyId] = useState(getComapnyId());

  const [productCategories, setProductCategories] = useState([]);

  const onFinish = (values) => {
    const meta = {
      category_1: find(get(productCategories, '0'), [
        'id',
        get(values, 'category_id_1'),
      ]),
      category_2: find(get(productCategories, '1'), [
        'id',
        get(values, 'category_id_2'),
      ]),
      category_3: find(get(productCategories, '2'), [
        'id',
        get(values, 'category_id_3'),
      ]),
      category_4: find(get(productCategories, '3'), [
        'id',
        get(values, 'category_id_4'),
      ]),
    };
    onSubmitPayload(
      0,
      assign(
        { ...values, is_sample: get(values, 'is_sample') === 1 },
        { meta, media }
      )
    );
  };

  const refreshCategories = async () => {
    setLoading(true);

    const responseArray = await Promise.all([
      dispatch(
        productMangement('list.product_categories', {
          company_id: companyId,
          filters: { type: 1 },
        })
      ),
      dispatch(
        productMangement('list.product_categories', {
          company_id: companyId,
          filters: { type: 2 },
        })
      ),
      dispatch(
        productMangement('list.product_categories', {
          company_id: companyId,
          filters: { type: 3 },
        })
      ),
      dispatch(
        productMangement('list.product_categories', {
          company_id: companyId,
          filters: { type: 4 },
        })
      ),
    ]);
    setLoading(false);
    setProductCategories(map(responseArray, 'data'));
  };

  const onSuccessAddCategory = (key, value) => {
    refreshCategories();
    form.setFieldsValue({ [key]: get(value, 'id') });
  };

  useEffect(() => {
    if (currentStep === 0 && companyId) {
      refreshCategories();
    }
  }, [currentStep, companyId]);

  return (
    <Spin spinning={loading}>
      <Form
        name="basic"
        layout="vertical"
        form={form}
        initialValues={
          initialValues
            ? {
                ...initialValues,
                is_sample: get(initialValues, 'is_sample') ? 1 : 0,
              }
            : { is_sample: 0 }
        }
        onFinish={onFinish}
        autoComplete="off"
        requiredMark
      >
        <Row gutter={32}>
          {isMarketingUser && (
            <Col xl={6}>
              <Form.Item
                label="Brand"
                name="company_id"
                className="form-item"
                rules={[
                  {
                    required: true,
                    message: 'Please select the Brand',
                  },
                ]}
              >
                <Select
                  size="large"
                  placeholder="Brand"
                  disabled={edit}
                  onChange={(value) => {
                    setCompanyId(value);
                  }}
                >
                  {map(userComapnies, (company) => (
                    <Option
                      value={get(company, 'Company.id')}
                      key={get(company, 'Company.name')}
                    >
                      {get(company, 'Company.name')}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          <Col xl={6}>
            <Form.Item
              label="Product Type"
              name="is_sample"
              className="form-item"
              rules={[
                {
                  required: true,
                  message: 'Please select the Product type!',
                },
              ]}
            >
              <Radio.Group
                disabled={edit}
                options={[
                  {
                    value: 1,
                    label: 'Sample',
                  },
                  {
                    value: 0,
                    label: 'Retail',
                  },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xl={6}>
            <Form.Item
              label="Main Category"
              name="category_id_1"
              className="form-item"
              rules={[
                {
                  required: true,
                  message: 'Please select a category!',
                },
              ]}
              extra={
                <AddCategory
                  categoryId={1}
                  refreshCategories={onSuccessAddCategory}
                  companyId={companyId}
                />
              }
            >
              <Select size="large" placeholder="Eg. Snacks" disabled={edit}>
                {map(get(productCategories, '0', []), (cat) => (
                  <Option value={get(cat, 'id')} key={get(cat, 'id')}>
                    {get(cat, 'name')}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xl={6}>
            <Form.Item
              label="Sub Category"
              name="category_id_2"
              className="form-item"
              rules={[
                {
                  required: true,
                  message: 'Please select a sub category!',
                },
              ]}
              extra={
                <AddCategory
                  categoryId={2}
                  refreshCategories={onSuccessAddCategory}
                  companyId={companyId}
                />
              }
            >
              <Select size="large" placeholder="Eg. Chips" disabled={edit}>
                {map(get(productCategories, '1', []), (cat) => (
                  <Option value={get(cat, 'id')} key={get(cat, 'id')}>
                    {get(cat, 'name')}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xl={6}>
            <Form.Item
              label="Sub-Sub Category"
              name="category_id_3"
              className="form-item"
              extra={
                <AddCategory
                  categoryId={3}
                  refreshCategories={onSuccessAddCategory}
                  companyId={companyId}
                />
              }
            >
              <Select size="large" placeholder="Eg. Fried" disabled={edit}>
                {map(get(productCategories, '2', []), (cat) => (
                  <Option value={get(cat, 'id')} key={get(cat, 'id')}>
                    {get(cat, 'name')}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xl={6}>
            <Form.Item
              label="Sub-Sub-Sub Category"
              name="category_id_4"
              className="form-item"
              extra={
                <AddCategory
                  categoryId={4}
                  refreshCategories={onSuccessAddCategory}
                  companyId={companyId}
                />
              }
            >
              <Select size="large" placeholder="Eg. Potato" disabled={edit}>
                {map(get(productCategories, '3', []), (cat) => (
                  <Option value={get(cat, 'id')} key={get(cat, 'id')}>
                    {get(cat, 'name')}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={32} className="mt-80">
          <Col xl={6}>
            <Form.Item
              label="Product Name"
              name="name"
              className="form-item"
              rules={[
                {
                  required: true,
                  message: 'Please input Product name!',
                },
              ]}
            >
              <Input size="large" placeholder="Enter Product name" />
            </Form.Item>
          </Col>
          <Col xl={6}>
            <Form.Item
              label="SKU Code"
              name="sku"
              className="form-item"
              rules={[
                {
                  required: true,
                  message: 'Please input SKU Code!',
                },
                {
                  max: 20,
                  message: 'SKU should not be greater than 20 character!',
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter SKU code"
                disabled={edit}
              />
            </Form.Item>
          </Col>
          <Col xl={6}>
            <Form.Item
              label="GS1Code"
              name="gs1"
              className="form-item"
              rules={[
                {
                  max: 13,
                  message: 'GS1 Code should of 13 character!',
                },
                {
                  min: 13,
                  message: 'GS1 Code should of  13 character!',
                },
                {
                  pattern: new RegExp(/^890[0-9]*$/),
                  message: 'GS1 Code is numeric and start with 890!',
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter GS1 code"
                disabled={edit}
              />
            </Form.Item>
          </Col>
          <Col
            xl={6}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <MediaUploadModal media={media} setMedia={setMedia} />
          </Col>
        </Row>
        <Row justify="center" className="mt-80">
          <Col xl={8}>
            <Button
              htmlType="submit"
              className="default-primary-btn"
              type="primary"
              block
            >
              Save & Proceed
            </Button>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default ProductDetailsForm;
